export function showShareToast(message) {
  if (typeof window === 'undefined' || !message) return;
  window.dispatchEvent(new CustomEvent('od:share-toast', { detail: { message } }));
}
